import Utils from '@/common/utils/utils';
import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';
import { I18n } from 'aws-amplify';
import { cloneDeep } from 'lodash';
import React from 'react';
import Constant from '@/common/constant/Constant';
import ProductManagementConstant from '@/common/constant/ProductManagementConstant';
import { TextField } from '@material-ui/core';

export default function CorporationProvideFunction({
    selectedProduct,
    selectedEdition,
    selectedVersion,
    listProvideFunction,
    setListProvideFunction,
    setListInvidualBasic,
    setIsEdit,
    corpActiveIsBlock,
    rootCorporationInfo,
    lincenseKey,
    licenseKeyInit,
    setLincenseKey,
    isRootSetting,
    isStandardSetting,
    setIsChangeLincenseKey,
    isSettingLicenseKeyByCorp
}) {
    const onChangeStatusResourceService = e => {
        setIsEdit(true);
        setListProvideFunction(prev => {
            let prevClone = cloneDeep(prev);
            let index = prevClone.findIndex(item => item.label === e.target.id);
            if (index !== -1) {
                switch (e.target.id) {
                    case Constant.ROOT_CORPORATION.PROVIDE_FUNCTION.LABEL_FUNCTION_PUBLIC_SERVICE_DESK_SETTINGS:
                        let indexPublicWebForm = prevClone.findIndex(
                            item =>
                                item.label ===
                                Constant.ROOT_CORPORATION.PROVIDE_FUNCTION
                                    .LABEL_FUNCTION_PUBLIC_WEB_FORM
                        );

                        if (indexPublicWebForm !== -1) {
                            prevClone[indexPublicWebForm].switchCorpDisabled = !e.target.checked;
                            if (!e.target.checked) {
                                prevClone[indexPublicWebForm].switchCorporation =
                                    Constant.STATUS_SERVICE_PERMISSION.OFF;
                            }
                        }

                        setListInvidualBasic(prevInvidual => {
                            const arrUpdate = [
                                Constant.ROOT_CORPORATION.INVIDUAL_BASIC_SETTING
                                    .LABEL_BASIC_NUMBER_OF_QA_COUNTER,
                                Constant.ROOT_CORPORATION.INVIDUAL_BASIC_SETTING
                                    .LABEL_BASIC_NUMBER_OF_SUPPORTED_COUNTER,
                                Constant.ROOT_CORPORATION.INVIDUAL_BASIC_SETTING
                                    .LABEL_BASIC_NUMBER_OF_B2C
                            ];

                            let invidualUpdate = prevInvidual.map(invidual => {
                                if (arrUpdate.includes(invidual.label)) {
                                    invidual.disabled = !e.target.checked;
                                    if (!e.target.checked) {
                                        invidual.value = '';
                                    }
                                }
                                return invidual;
                            });

                            return invidualUpdate;
                        });

                        break;
                    case Constant.ROOT_CORPORATION.PROVIDE_FUNCTION.LABEL_FUNCTION_SOLUTIONDESK_KNOWLEDGE:
                        let indexConvertPDF = prevClone.findIndex(
                            item =>
                                item.label ===
                                Constant.ROOT_CORPORATION.PROVIDE_FUNCTION
                                    .LABEL_FUNCTION_CONVERT_PDF
                        );

                        if (indexConvertPDF !== -1) {
                            prevClone[indexConvertPDF].switchCorpDisabled = !e.target
                                .checked;
                            if (!e.target.checked) {
                                prevClone[indexConvertPDF].switchCorporation =
                                    Constant.STATUS_SERVICE_PERMISSION.OFF;
                            }
                        }

                        let indexPublicKnowledgeSite = prevClone.findIndex(
                            item =>
                                item.label ===
                                Constant.ROOT_CORPORATION.PROVIDE_FUNCTION
                                    .LABEL_FUNCTION_PUBLIC_KNOWLEDGE_SITE
                        );

                        if (indexPublicKnowledgeSite !== -1) {
                            prevClone[indexPublicKnowledgeSite].switchCorpDisabled = !e.target
                                .checked;
                            if (!e.target.checked) {
                                prevClone[indexPublicKnowledgeSite].switchCorporation =
                                    Constant.STATUS_SERVICE_PERMISSION.OFF;
                            }
                        }

                        let indexKnowledgeBot = prevClone.findIndex(
                            item =>
                                item.label ===
                                Constant.ROOT_CORPORATION.PROVIDE_FUNCTION
                                    .LABEL_FUNCTION_KNOWLEDGE_BOT
                        );

                        if (indexKnowledgeBot !== -1) {
                            prevClone[indexKnowledgeBot].switchCorpDisabled = !e.target.checked;
                            if (!e.target.checked) {
                                prevClone[indexKnowledgeBot].switchCorporation =
                                    Constant.STATUS_SERVICE_PERMISSION.OFF;
                            }
                        }

                        let indexSynonymSearch = prevClone.findIndex(
                            item =>
                                item.label ===
                                Constant.ROOT_CORPORATION.PROVIDE_FUNCTION
                                    .LABEL_FUNCTION_SYNONYM_SEARCH
                        );

                        if (indexSynonymSearch !== -1) {
                            prevClone[indexSynonymSearch].switchCorpDisabled = !e.target.checked;
                            if (!e.target.checked) {
                                prevClone[indexSynonymSearch].switchCorporation =
                                    Constant.STATUS_SERVICE_PERMISSION.OFF;
                            }
                        }

                        let indexBatchCommandService = prevClone.findIndex(
                            item =>
                                item.label ===
                                Constant.ROOT_CORPORATION.PROVIDE_FUNCTION
                                    .LABEL_BATCH_COMMAND
                        );

                        if (indexBatchCommandService !== -1) {
                            prevClone[indexBatchCommandService].switchCorpDisabled = !e.target.checked;
                            if (!e.target.checked) {
                                prevClone[indexBatchCommandService].switchCorporation =
                                    Constant.STATUS_SERVICE_PERMISSION.OFF;
                            }
                        }

                        setListInvidualBasic(prevInvidual => {
                            const arrUpdate = [
                                Constant.ROOT_CORPORATION.INVIDUAL_BASIC_SETTING
                                    .LABEL_BASIC_NUMBER_OF_KNOWLEDGE
                            ];

                            let invidualUpdate = prevInvidual.map(invidual => {
                                if (arrUpdate.includes(invidual.label)) {
                                    invidual.disabled = !e.target.checked;
                                    if (!e.target.checked) {
                                        invidual.value = '';
                                    }
                                }
                                return invidual;
                            });

                            return invidualUpdate;
                        });

                        break;
                    case Constant.ROOT_CORPORATION.PROVIDE_FUNCTION.LABEL_FUNCTION_LINCENSE_KEY_PERMISSION:
                        const licenseKeyOfProductObj = selectedProduct?.moduleSetting?.lincenseKeySetting
                        const isTurnOnLicenseKeySetting = prevClone[index].switchCorpDisabled
                        let productLicenseKey = ''

                        /**when switch 貸出ライセンスキー利用を許可する OFF -> ON and OpenAIライセンスキー is empty. fill value   OpenAIライセンスキー from product version to value setting in root corp.  */
                        if(!Utils.isEmptyString(licenseKeyOfProductObj?.key)){
                            productLicenseKey = licenseKeyOfProductObj?.key
                        }
                        if (
                            e.target.checked &&
                            !isTurnOnLicenseKeySetting &&
                            Utils.isEmptyString(lincenseKey?.value)
                        ) {
                            setLincenseKey(prev => {
                                return {
                                    ...prev,
                                    value: productLicenseKey,
                                    error: ''
                                };
                            });
                            if (e.target.checked && Utils.isEmptyString(productLicenseKey)) {
                                setIsEdit(false);
                            }
                        //.end
                        } else {
                            setLincenseKey(prev => {
                                return {
                                    ...prev,
                                    error: ''
                                };
                            });
                            if (e.target.checked && Utils.isEmptyString(lincenseKey?.value)) {
                                setIsEdit(false);
                            }
                        }
                        break;
                    case Constant.ROOT_CORPORATION.PROVIDE_FUNCTION.LABEL_FUNCTION_CHAT_AI:
                        let indexLicenseKey = prevClone.findIndex(
                            item =>
                                item.label ===
                                Constant.ROOT_CORPORATION.PROVIDE_FUNCTION
                                    .LABEL_FUNCTION_LINCENSE_KEY_PERMISSION
                        );

                        if (indexLicenseKey !== -1) {
                            prevClone[indexLicenseKey].switchCorpDisabled = !e.target.checked;
                            if (!e.target.checked) {
                                prevClone[indexLicenseKey].switchCorporation =
                                    Constant.STATUS_SERVICE_PERMISSION.OFF;
                                setLincenseKey(prevLincenKey => ({
                                    ...prevLincenKey,
                                    error: ''
                                }));
                            }
                        }
                        let indexAIAuto = prevClone.findIndex(
                            item =>
                                item.label ===
                                Constant.ROOT_CORPORATION.PROVIDE_FUNCTION
                                    .LABEL_FUNCTION_AI_AUTO
                        );

                        if (indexAIAuto !== -1) {
                            prevClone[indexAIAuto].switchCorpDisabled = !e.target.checked;
                            if (!e.target.checked) {
                                prevClone[indexAIAuto].switchCorporation =
                                    Constant.STATUS_SERVICE_PERMISSION.OFF;
                            }
                        }
                        break;
                    default:
                        break;
                }

                prevClone[index].switchCorporation = e.target.checked
                    ? Constant.STATUS_SERVICE_PERMISSION.ON
                    : Constant.STATUS_SERVICE_PERMISSION.OFF;
            }
            return prevClone;
        });
        setLincenseKey(prev => ({
            ...prev,
            value: licenseKeyInit
        }));
    };

    let text = `${selectedProduct.label} ${selectedEdition.label} (${selectedVersion.label})`;

    const handleDisableLincenseKeyInput = () => {
        let isPermissionLincenseKeyOn = false;
        let permissionKeyData = listProvideFunction.find(funct => funct.label === Constant.ROOT_CORPORATION.PROVIDE_FUNCTION.LABEL_FUNCTION_LINCENSE_KEY_PERMISSION);
        if (permissionKeyData && permissionKeyData.switchCorporation === Constant.STATUS_SERVICE_PERMISSION.ON) {
            isPermissionLincenseKeyOn = true;
        }
        let isChatAiOn = false;
        let chatAiData = listProvideFunction.find(funct => funct.label === Constant.ROOT_CORPORATION.PROVIDE_FUNCTION.LABEL_FUNCTION_CHAT_AI);
        if (chatAiData && chatAiData.switchCorporation === Constant.STATUS_SERVICE_PERMISSION.ON) {
            isChatAiOn = true;
        }
        return !(isChatAiOn && isPermissionLincenseKeyOn);
    };

    const handleChangeInputLincenseKey = (e) => {
        let lincenseKeyValue = e.target.value.trim();
        setIsEdit(true);
        setIsChangeLincenseKey(true);
        setLincenseKey(prev => {
            return {
                ...prev,
                value: lincenseKeyValue,
                error: ''
            };
        });
    };

    const isSettingAIOn = () => {
        let isAIOn = false;

        let aiData = listProvideFunction.find(funct => funct.label === Constant.ROOT_CORPORATION.PROVIDE_FUNCTION.LABEL_FUNCTION_CHAT_AI);
        if (aiData && aiData.switchCorporation === Constant.STATUS_SERVICE_PERMISSION.ON) {
            isAIOn = true;
        }

        return isAIOn;
    }

    return (
        <>
            <div className="pl-16 pr-16 head-title-provide">
                <span>提供機能:</span>
                <OverFlowTooltipWithTabsMui value={text} className="name-info-product" />
            </div>

            <div className="table-head-provide">
                <div></div>
                <div>
                    <div>基本設定</div>
                    <div>個別設定</div>
                </div>
            </div>
            
            {!Utils.isEmptyArray(listProvideFunction) &&
                listProvideFunction?.map(provide => {
                    switch (provide.label) {
                        case Constant.ROOT_CORPORATION.PROVIDE_FUNCTION.LABEL_FUNCTION_CHAT_AI:
                            return (
                                <div
                                    className={`${provide.usedToCustomize &&
                                        provide.switchCorporationDefault != provide.switchVersion &&
                                        'item-provide-background'} item-provide setting-item`}
                                    key={provide.label}
                                >
                                    <div>{I18n.get(provide?.label)}</div>
                                    <div>
                                        <div className="switch-check">
                                            <input
                                                id={`${provide?.label}-version`}
                                                type="checkbox"
                                                checked={provide?.switchVersion}
                                                disabled
                                            />
                                            <label htmlFor={`${provide?.label}-version`}></label>
                                        </div>
                                        <div className="switch-check">
                                            <input
                                                id={provide?.label}
                                                type="checkbox"
                                                checked={provide?.switchCorporation}
                                                // checked={checked}
                                                disabled={provide?.switchCorpDisabled || corpActiveIsBlock}
                                                onChange={e => onChangeStatusResourceService(e)}
                                            />
                                            <label htmlFor={provide?.label}></label>
                                        </div>
                                    </div>
                                </div>
                            );
                        case Constant.ROOT_CORPORATION.PROVIDE_FUNCTION.LABEL_FUNCTION_LINCENSE_KEY_PERMISSION:
                            return (
                                <>
                                    {(
                                        <div className={`${provide.usedToCustomize &&
                                            provide.switchCorporationDefault != provide.switchVersion &&
                                            'item-provide-background'} setting-item-ai-key lincenseKey`} key={provide.label} >
                                            <div className="setting-children-item lincenseKeyPermission-item">
                                                <label>{I18n.get(provide?.label)}</label>
                                                <div className='item-provide-license-permission'>
                                                    <div className="switch-check">
                                                        <input
                                                            id={`${provide?.label}-version`}
                                                            type="checkbox"
                                                            checked={provide?.switchVersion}
                                                            disabled
                                                        />
                                                        <label htmlFor={`${provide?.label}-version`}></label>
                                                    </div>
                                                    <div className="switch-check">
                                                        <input
                                                            id={provide?.label}
                                                            type="checkbox"
                                                            checked={provide?.switchCorporation}
                                                            // checked={checked}
                                                            disabled={provide?.switchCorpDisabled || corpActiveIsBlock || !isSettingAIOn()}
                                                            onChange={e => onChangeStatusResourceService(e)}
                                                        />
                                                        <label htmlFor={provide?.label}></label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="setting-children-item lincenseKey-input-label">
                                                <label className="setting-label">{ProductManagementConstant.TEXTBOX_SETTING_LINCENSE_KEY}</label>
                                            </div>
                                            <div style={{display: 'flex'}}>  
                                                <div className="setting-children-item line-stream"></div>
                                            <TextField
                                                className="form-control-input form-control-wrapInput form-control-hg32 lincenseKey-input-version"
                                                variant="outlined"
                                                spellCheck={false}
                                                type="text"
                                                value={lincenseKey?.value}
                                                disabled={handleDisableLincenseKeyInput()}
                                                onChange={e => handleChangeInputLincenseKey(e)}
                                                onBlur={e => {
                                                    if (Utils.isEmptyString(e.target.value)) {
                                                        setLincenseKey(prev => ({
                                                            ...prev,
                                                            error: I18n.get('COMMSG014')
                                                        }));
                                                        setIsEdit(false)
                                                    }
                                                }}
                                                onWheel={e => e.target.blur()}
                                                helperText={lincenseKey?.error}
                                                error={!Utils.isEmptyString(lincenseKey?.error)}
                                            />
                                            </div>
                                            {isSettingLicenseKeyByCorp && <div style={{display: 'flex'}}>
                                                <div className="setting-children-item line-stream"></div>
                                                <p style={{color: 'green'}}>{I18n.get('LABEL-USING-YOUR-ORG-LICENSE-KEY')}</p>
                                            </div>}
                                        </div>
                                    )}
                                </>
                            );
                        case Constant.ROOT_CORPORATION.PROVIDE_FUNCTION.LABEL_FUNCTION_AI_AUTO:
                            return (
                                <>
                                    {(
                                        <div className={`${provide.usedToCustomize &&
                                            provide.switchCorporationDefault != provide.switchVersion &&
                                            'item-provide-background'} setting-item-ai-auto border-bottom lincenseKey`} key={provide.label} >
                                            <div className="setting-children-item lincenseKeyPermission-item">
                                                <label>{I18n.get(provide?.label)}</label>
                                                <div className='item-provide-license-permission'>
                                                    <div className="switch-check">
                                                        <input
                                                            id={`${provide?.label}-version`}
                                                            type="checkbox"
                                                            checked={provide?.switchVersion}
                                                            disabled
                                                        />
                                                        <label htmlFor={`${provide?.label}-version`}></label>
                                                    </div>
                                                    <div className="switch-check">
                                                        <input
                                                            id={provide?.label}
                                                            type="checkbox"
                                                            checked={provide?.switchCorporation}
                                                            // checked={checked}
                                                            // disabled={provide?.switchCorpDisabled || corpActiveIsBlock}
                                                            disabled={provide?.switchCorpDisabled || corpActiveIsBlock || !isSettingAIOn()}
                                                            onChange={e => onChangeStatusResourceService(e)}
                                                        />
                                                        <label htmlFor={provide?.label}></label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </>
                            );
                        default:
                            return (
                                <div
                                    className={`${provide.usedToCustomize &&
                                        provide.switchCorporationDefault != provide.switchVersion &&
                                        'item-provide-background'} item-provide`}
                                    key={provide.label}
                                >
                                    <div>{I18n.get(provide?.label)}</div>
                                    <div>
                                        <div className="switch-check">
                                            <input
                                                id={`${provide?.label}-version`}
                                                type="checkbox"
                                                checked={provide?.switchVersion}
                                                disabled
                                            />
                                            <label htmlFor={`${provide?.label}-version`}></label>
                                        </div>
                                        <div className="switch-check">
                                            <input
                                                id={provide?.label}
                                                type="checkbox"
                                                checked={provide?.switchCorporation}
                                                // checked={checked}
                                                disabled={provide?.switchCorpDisabled || corpActiveIsBlock}
                                                onChange={e => onChangeStatusResourceService(e)}
                                            />
                                            <label htmlFor={provide?.label}></label>
                                        </div>
                                    </div>
                                </div>
                            );
                    }
                })}
        </>
    );
}
